import env from 'utils/environment';

import { config } from './video-dreams-banner.settings';

const getVideoUrl = (isMobile: boolean): string => {
  if (env.isDevelopment || env.isLocalhost) {
    return (isMobile && config.video.dev.mobile) || config.video.dev.desktop;
  }

  return (isMobile && config.video.prod.mobile) || config.video.prod.desktop;
};

export { getVideoUrl };
